export function parseErrorMessage(
  message: string | null | undefined,
  fallbackMessage = 'Something went wrong',
  isDebugMode = false,
): string {
  if (!message) {
    return fallbackMessage;
  }

  if (isDebugMode) {
    // In debug mode, show the raw message
    return message;
  }

  // Try to extract nested JSON from the message
  // Handle cases like: "(400, '{"message":"Actual error","type":"Bad Request","code":400}')"
  const messageMatch = /"message"\s*:\s*"((?:[^"\\]|\\.)*)"/.exec(message);
  if (messageMatch?.[1]) {
    // Unescape any escaped quotes in the extracted message
    const extractedMessage = messageMatch[1].replace(/\\"/g, '"');

    return extractedMessage || fallbackMessage;
  }

  return message;
}
